export const ICON_SIZE = 16;
export const ALERT_SIZE = 8;
export const NAVBAR_HEIGHT_SM = 64;
export const NAVBAR_HEIGHT = 64;
